<!-- The standard in-place loading state: use it wherever a table, list or panel
     has nothing to show yet, so an empty state never stands in for pending data.
     `inline` swaps the centred block for a compact row, for the spots where the
     indicator sits beside other content rather than standing in for it; callers
     add their own spacing and alignment classes there. -->
<template>
  <div
    :class="inline ? 'd-flex align-items-center gap-2' : 'text-center py-5'"
    role="status"
  >
    <div
      class="spinner-border text-primary"
      :class="inline ? 'spinner-border-sm' : undefined"
    ></div>
    <span
      v-if="message"
      class="text-muted"
      :class="inline ? undefined : 'd-block mt-2'"
    >
      {{ message }}
    </span>
    <span v-else class="visually-hidden">{{ $t("common.loading") }}</span>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    /** Visible copy beside or under the spinner; falls back to a screen-reader-only "Loading". */
    message?: string;
    /** Compact single-row layout for where the indicator accompanies other content. */
    inline?: boolean;
  }>(),
  { message: undefined, inline: false }
);
</script>
